import * as React from "react";
import { SVGProps, memo } from "react";

const SvgHomeFailed = (props: SVGProps<SVGSVGElement>) => (
  <svg width={128} height={114} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#HomeFailed_svg__a)">
      <mask
        id="HomeFailed_svg__b"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={36}
        y={61}
        width={21}
        height={36}
      >
        <path d="M56.873 61.555h-20.04v34.7h20.04v-34.7Z" fill="#fff" />
      </mask>

      <g mask="url(#HomeFailed_svg__b)">
        <path
          d="M50.893 65.102s.667 5.354-.287 10.227a8.542 8.542 0 0 1-.92 2.5c-.473.86-2.073 2.38-2.993 2.873-3.153 1.7-6.66 2.86-6.66 2.86-1.346.6-2.54 3.06-1.886 5.367.9 3.173 3.04 3.78 5.473 4.467.64.18 1.28.38 2.287.546 5.4.92 11.133 1.894 14.186.394 4.467-2.187 1.193-10.04.24-17.847-.727-5.933 1.92-12.247-1.5-13.613-2.653-1.06-7.94 2.206-7.94 2.206v.02Z"
          fill="#fff"
          stroke="#272C33"
          strokeWidth={2.26}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="HomeFailed_svg__c"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={56}
        y={61}
        width={21}
        height={36}
      >
        <path d="M76.913 61.555h-20.04v34.7h20.04v-34.7Z" fill="#fff" />
      </mask>

      <g mask="url(#HomeFailed_svg__c)">
        <path
          d="M62.854 65.102s-.667 5.354.286 10.227c.114.587.36 1.487.92 2.5.474.86 2.074 2.38 2.994 2.873 3.153 1.7 6.66 2.86 6.66 2.86 1.346.6 2.54 3.06 1.886 5.367-.9 3.173-3.04 3.78-5.473 4.467-.64.18-1.28.38-2.287.546-5.4.92-11.133 1.894-14.186.394-4.467-2.187-1.194-10.04-.24-17.847.726-5.933-1.92-12.247 1.5-13.613 2.653-1.06 7.94 2.206 7.94 2.206v.02Z"
          fill="#fff"
          stroke="#272C33"
          strokeWidth={2.26}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M73.767 83.58s-3.507-1.167-6.66-2.86c-.92-.494-2.52-2.02-2.994-2.874a8.545 8.545 0 0 1-.92-2.5c-.953-4.873-.286-10.226-.286-10.226s-1.427-.88-3.167-1.574c-.24-.26-.533-.48-.913-.633-.554-.22-1.22-.247-1.934-.16-.706-.087-1.38-.06-1.933.16-.38.153-.667.367-.913.633-1.74.7-3.167 1.574-3.167 1.574s.667 5.353-.287 10.226a8.542 8.542 0 0 1-.92 2.5c-.473.86-2.073 2.38-2.993 2.874-3.153 1.7-6.66 2.86-6.66 2.86-1.347.6-2.54 3.06-1.887 5.366.9 3.174 3.04 3.78 5.474 4.467.64.18 1.28.38 2.286.547 3.867.653 7.894 1.34 11 1.126 3.1.214 7.134-.466 11-1.126 1.007-.174 1.647-.367 2.287-.547 2.433-.693 4.573-1.293 5.473-4.467.654-2.306-.54-4.766-1.886-5.366Z"
        fill="#fff"
      />

      <path
        d="M73.767 83.58s-3.507-1.167-6.66-2.86c-.92-.494-2.52-2.02-2.994-2.874a8.545 8.545 0 0 1-.92-2.5c-.953-4.873-.286-10.226-.286-10.226s-1.427-.88-3.167-1.574c-.24-.26-.533-.48-.913-.633-.554-.22-1.22-.247-1.934-.16-.706-.087-1.38-.06-1.933.16-.38.153-.667.367-.913.633-1.74.7-3.167 1.574-3.167 1.574s.667 5.353-.287 10.226a8.542 8.542 0 0 1-.92 2.5c-.473.86-2.073 2.38-2.993 2.874-3.153 1.7-6.66 2.86-6.66 2.86-1.347.6-2.54 3.06-1.887 5.366.9 3.174 3.04 3.78 5.474 4.467.64.18 1.28.38 2.286.547 3.867.653 7.894 1.34 11 1.126 3.1.214 7.134-.466 11-1.126 1.007-.174 1.647-.367 2.287-.547 2.433-.693 4.573-1.293 5.473-4.467.654-2.306-.54-4.766-1.886-5.366Z"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M42.6 85.061c9.573 1.367 19.347 1.367 28.9-.12a2.258 2.258 0 0 0-.013.354 36.19 36.19 0 0 1 6.76 14.573c.353 1.667.586 3.36.826 5.047.407 2.9.807 5.8 1.214 8.7.333 2.38.66 4.753.933 7.14 1.493 13.246 1.067 26.653 2.593 39.933-.18.247-.08.647.207.753 0 .027-.013.054-.107.014-3.5 1.42-7.366 1.593-11.14 1.74l-15.726.62c-3.34.133-6.694.266-10.02-.02-5.614-.474-11.047-2.12-16.434-3.747-.18-9.44.407-18.893 1.747-28.24 1.433-10.04 3.74-19.947 4.907-30.02.313-2.727.553-5.48 1.3-8.12.84-2.973 2.3-5.727 4.073-8.607h-.02Z"
        fill="#CAECD1"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M30.133 133.403c-1.433-1.24 5.067 1.62 5.067 1.62l1.673-5.3c2.567-4.86-.333-5.52 3.107-12.907 3.367-7.226 7.193-16.566 7.933-21.086.214-1.3.247-2.64-.086-3.913-.747-2.86-1.614-4.22-4.934-5.354 0 0-2.193-.693-4.753-.2-1.607.307-2.967 1.107-2.967 1.107A37.207 37.207 0 0 0 23.9 102.236c-1.187 2.86-2.013 5.847-2.833 8.834-2.214 8.053-5.934 12.893-4.7 17.906.566 2.307 16.62 6.894 13.76 4.42l.006.007Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M78.94 125.118c-2.973-4.627-2.626-4.007-6.686-11.073-3.967-6.914-8.58-15.894-9.707-20.334-.32-1.273-.473-2.613-.247-3.906.5-2.914 1.247-4.34 4.46-5.754 0 0 2.127-.873 4.72-.6 1.627.174 3.054.847 3.054.847a37.233 37.233 0 0 1 12.5 13.853c1.426 2.747 2.506 5.66 3.573 8.56 2.893 7.834 7.093 15.3 8.68 23.5 1.193 6.167-1.64 11.714-7.14 14.2-3.48 1.574-18.907.207-25.507-.826-.693-8.074-.46-15.42 1.16-17.74 4.054-.347 16-.267 20.82-.1M42.406 82.069c-2.533 1.233-5.706 4.22-6.973 5.126-.287.207-9.487 61.247-17 142.74 9.98 2.074 22.413 2.827 32.467 1.127 0 0 4.16-83.387-3.947-152.593-1.6.453-2.98 1.213-3.987 1.86-.36.233-.54 1.713-.633 2.133-.613 2.813-.813 3.633-1.253 6.58-.434 2.88-1.247 5.7-1.494 8.6-.026.307-.046.627.054.913.12.347.406.614.68.86a97.67 97.67 0 0 0 6.053 5.054c-1.193 2.266-2.387 4.526-3.58 6.793-.12.233-.247.473-.233.733.013.254.146.487.286.7 2.627 4.22 5.254 8.434 7.88 12.654"
        fill="#fff"
      />

      <path
        d="M31.266 115.595c-3.333 23.747-7.713 58.767-12.833 114.34 9.98 2.074 25.72 2.794 35.773 1.1 0 0 1.12-86.866 1.1-99.553v-5.2c-.76-16.96-6.4-31.133-8.353-47.813-1.6.453-2.98 1.213-3.987 1.86-.36.233-.54 1.713-.633 2.133-.613 2.813-.813 3.633-1.253 6.58-.434 2.88-1.247 5.7-1.494 8.6-.026.307-.046.627.054.913.12.347.406.614.68.86a97.67 97.67 0 0 0 6.053 5.054c-1.193 2.266-2.387 4.526-3.58 6.793-.12.233-.247.473-.233.733.013.254.206.447.34.66 2.626 4.22 9.033 9.54 11.66 13.76"
        fill="#fff"
      />

      <path
        d="M31.266 115.595c-3.333 23.747-7.713 58.767-12.833 114.34 9.98 2.074 25.72 2.794 35.773 1.1 0 0 1.12-86.866 1.1-99.553v-5.2c-.76-16.96-6.4-31.133-8.353-47.813-1.6.453-2.98 1.213-3.987 1.86-.36.233-.54 1.713-.633 2.133-.613 2.813-.813 3.633-1.253 6.58-.434 2.88-1.247 5.7-1.494 8.6-.026.307-.046.627.054.913.12.347.406.614.68.86a97.67 97.67 0 0 0 6.053 5.054c-1.193 2.266-2.387 4.526-3.58 6.793-.12.233-.247.473-.233.733.013.254.206.447.34.66 2.626 4.22 9.033 9.54 11.66 13.76"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M42.407 82.07c-2.534 1.234-6.374 4.734-7.64 5.647l7.64-5.647Z" fill="#fff" />

      <path
        d="M42.407 82.07c-2.534 1.234-6.374 4.734-7.64 5.647"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M71.327 82.065c2.534 1.233 5.707 4.22 6.974 5.127.286.206 9.486 61.246 17 142.74-9.98 2.073-22.414 2.826-32.467 1.126 0 0-4.16-83.386 3.947-152.593 1.6.453 2.98 1.213 3.986 1.86.36.233.54 1.713.633 2.133.614 2.814.814 3.633 1.254 6.58.433 2.88 1.246 5.7 1.493 8.6.027.307.047.627-.053.913-.12.347-.407.614-.68.86a97.762 97.762 0 0 1-6.053 5.054c1.193 2.267 2.386 4.527 3.58 6.793.12.234.246.474.233.734-.014.253-.147.486-.287.7l-7.88 12.653"
        fill="#fff"
      />

      <path
        d="M82.527 116.21c3.333 23.747 7.64 58.14 12.766 113.714-9.98 2.073-25.72 2.793-35.773 1.1 0 0-1.12-86.867-1.1-99.554v-5.2c.76-16.96 6.4-31.133 8.353-47.813 1.6.453 2.98 1.213 3.987 1.86.36.233.54 1.713.633 2.133.614 2.814.814 3.634 1.254 6.58.433 2.88 1.246 5.7 1.493 8.6.027.307.047.627-.053.914-.12.346-.407.613-.68.86a97.802 97.802 0 0 1-6.053 5.053c1.193 2.267 2.386 4.527 3.58 6.793.12.234.246.474.233.734-.014.253-.207.446-.34.66-2.627 4.22-9.033 9.54-11.66 13.76"
        fill="#fff"
      />

      <path
        d="M82.527 116.21c3.333 23.747 7.64 58.14 12.766 113.714-9.98 2.073-25.72 2.793-35.773 1.1 0 0-1.12-86.867-1.1-99.554v-5.2c.76-16.96 6.4-31.133 8.353-47.813 1.6.453 2.98 1.213 3.987 1.86.36.233.54 1.713.633 2.133.614 2.814.814 3.634 1.254 6.58.433 2.88 1.246 5.7 1.493 8.6.027.307.047.627-.053.914-.12.346-.407.613-.68.86a97.802 97.802 0 0 1-6.053 5.053c1.193 2.267 2.386 4.527 3.58 6.793.12.234.246.474.233.734-.014.253-.207.446-.34.66-2.627 4.22-9.033 9.54-11.66 13.76"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path d="M71.327 82.063c2.534 1.233 5.707 4.22 6.974 5.126l-6.974-5.126Z" fill="#fff" />

      <path
        d="M71.327 82.063c2.534 1.233 5.707 4.22 6.974 5.126"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="m86.323 119.043-29.43-3.629a1.593 1.593 0 0 0-1.776 1.386l-5.027 40.758a1.593 1.593 0 0 0 1.387 1.776l29.43 3.63a1.594 1.594 0 0 0 1.776-1.387l5.027-40.758a1.593 1.593 0 0 0-1.387-1.776Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M78.527 87.344c3.68 3.533 5.927 5.266 9.02 10.733.62 1.093 1.72 3.527 3.88 8.427 4.873 11.06 6.433 15.56 7.467 20.66.813 4.006.92 6.52.12 9.206-.354 1.18-1.394 4.527-4.407 6.76-2.04 1.507-2.853 2.034-10.127 3.714-3.813.88-15.6 4.073-18.206 4.473-.787-1.493-2.6-6.647-3.607-10.613-.387-1.52-.907-2.954-.907-5.06 4.594-1.667 24.38-7.627 26.92-8"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M66.626 90.073c-.44.4-2.006 1.914-2.14 4.254-.073 1.353.367 2.366.614 2.92 1.293 2.873 4.073 4.1 4.986 4.46 0 0-1.466-2.394-1.326-4.474.146-2.08.873-3.8 2.12-5.42 1.466-1.9 2.24-2.78 4.1-4.24 1.833-1.44 3.146-3.24 4.473-5.206 1.6-2.38 1.453-5.974.787-8.814-.667-2.833-1.9-6.373-7.727-10.8-1.42-1.326-2.26-.506-2.26-.506s-1.333.993-.04 2.453c.02.02-.007-.04-.02-.013-.013.026.02.04 0 .013 0 0 .893 2.307.653 3.807-.246 1.5-1.386 4.886-2.106 5.906-.72 1.02-2.98 4.06-3.36 4.46-.38.4-2.86 2.52-3.234 3.7-.373 1.18-1.26 2.207-.76 4.547.507 2.34 2.007 4.067 2.007 4.067s-.033 1.6.707 3.233c.626 1.387.18.86.713 1.393.093.094.247.207.393.407M73.4 7.686C66.04 1.632 55.413.679 47.193 5.332l.027.02c-25.093 7.474-24.053 39.854-8.82 54.114 7.307 6.84 17.433 9.693 28.573 4.346 0 0 13.267-8.593 16.5-16.106.934-2.174 2.287-5.567 2.687-9.22.667-6.134-.113-12.48-2.513-18.107-2.4-5.633-6.447-10.513-11.554-13.513"
        fill="#2BA168"
      />

      <path
        d="M63.38 90.686c-1.506-1.58-2.246-4.013-1.94-6.2.26-1.853 1.747-3.64 3.047-4.967 2.367-2.42 4.4-4.453 5.613-7.513 1.214-3.06 1.64-5.393.354-7.653 0 0-1.187-1.274-.194-2.214 1.454-1.366 2.554-.046 2.554-.046 5.986 4.36 7.473 8.166 8.16 10.993.686 2.827.84 6.413-.814 8.793-1.36 1.96-2.72 3.76-4.606 5.194-1.92 1.46-2.714 2.333-4.227 4.233-1.287 1.613-2.033 3.327-2.187 5.407-.153 2.08 1.367 4.46 1.367 4.46-1.98-1.007-3.653-1.5-5-3.32-.993-1.347-2.907-5.054-2.127-7.167ZM72.814 7.686c-6.46-4.333-12.967-6.193-19.82-4.826a22.957 22.957 0 0 0-6.734 2.473l.027.02c-7.793 2.293-11.633 6.92-14.8 12.647-7.173 12.966-4.847 31.573 5.86 41.466 7.407 6.84 17.667 9.693 28.96 4.347 0 0 13.447-8.594 16.727-16.107.946-2.173 2.32-5.567 2.72-9.22.68-6.133-.114-12.48-2.547-18.106-2.433-5.634-6.993-10.414-10.38-12.687l-.013-.007Z"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="HomeFailed_svg__d"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={28}
        y={12}
        width={30}
        height={61}
      >
        <path d="M58 12.969H28.486v59.813H58V12.97Z" fill="#fff" />
      </mask>

      <g mask="url(#HomeFailed_svg__d)">
        <path
          d="M59.548 72.785c-1.988-.067-4.979-.4-6.595-.8-2.991-.74-6.505-1.96-10.81-5.76-2.427-2.14-4.07-4.573-5.625-7.933-3.348-.447-6.374-2.754-7.543-5.807-.46-1.207-.646-2.54-.344-3.794.303-1.253 1.114-2.42 2.304-3.006 1.19-.587 2.73-.52 3.514-.1-1.438-6.707-.688-13.834 2.11-20.12 1.232-2.76 2.875-5.393 5.172-7.407 3.17-2.787 7.406-4.226 11.648-4.767 4.243-.546 8.548-.253 12.818.034"
          fill="#fff"
        />
      </g>

      <mask
        id="HomeFailed_svg__e"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={57}
        y={12}
        width={29}
        height={61}
      >
        <path d="M85.713 12.969H57.1v59.813h28.613V12.97Z" fill="#fff" />
      </mask>

      <g mask="url(#HomeFailed_svg__e)">
        <path
          d="M55.6 72.786c1.927-.067 4.827-.4 6.393-.8 2.9-.74 6.307-1.96 10.48-5.76 2.354-2.14 3.947-4.573 5.454-7.933 3.246-.447 6.18-2.754 7.313-5.807.447-1.207.627-2.54.333-3.793-.293-1.254-1.08-2.42-2.233-3.007-1.147-.587-2.647-.52-3.407-.1a33.8 33.8 0 0 0-2.046-20.12c-1.194-2.76-2.787-5.393-5.014-7.407-3.073-2.786-7.18-4.226-11.293-4.766-4.113-.54-8.287-.254-12.427.033"
          fill="#fff"
        />
      </g>

      <path
        d="M51.066 71.742c-2.04-.687-5.42-1.993-9.2-5.433-2.433-2.214-4.08-4.727-5.633-8.2-3.353-.467-6.393-2.847-7.56-6-.46-1.247-.647-2.627-.347-3.92.3-1.3 1.12-2.5 2.307-3.107 1.187-.607 2.733-.54 3.52-.107-.447-3.88-1.08-13.226 2.98-21.64 2.2-4.56 4.773-6.753 5.367-7.246 2.826-2.34 5.586-3.327 7.7-3.84 6.9-1.674 14.06-.387 15.773.733"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M62.687 71.626c2.04-.687 5.42-1.994 9.2-5.434 2.433-2.213 4.08-4.726 5.633-8.2 3.353-.466 6.393-2.846 7.56-6 .46-1.246.647-2.627.347-3.92-.3-1.3-1.12-2.5-2.307-3.107-1.187-.606-2.733-.54-3.52-.106.447-3.88 1.08-13.227-2.98-21.64-2.2-4.56-4.773-6.754-5.367-7.247-2.826-2.34-5.613-3.213-7.7-3.84-6.246-1.88-11.666.06-15.473.813"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <mask
        id="HomeFailed_svg__f"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={40}
        y={33}
        width={9}
        height={5}
      >
        <path d="M48.547 33.129h-7.666v4.033h7.666V33.13Z" fill="#fff" />
      </mask>

      <g mask="url(#HomeFailed_svg__f)">
        <path
          d="M47.867 33.805a9.64 9.64 0 0 0-6.313 2.68"
          stroke="#272C33"
          strokeWidth={1.353}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <mask
        id="HomeFailed_svg__g"
        style={{
          maskType: "luminance",
        }}
        maskUnits="userSpaceOnUse"
        x={65}
        y={33}
        width={9}
        height={5}
      >
        <path d="M73.074 33.129h-7.667v4.033h7.667V33.13Z" fill="#fff" />
      </mask>

      <g mask="url(#HomeFailed_svg__g)">
        <path
          d="M66.087 33.805a9.64 9.64 0 0 1 6.313 2.68"
          stroke="#272C33"
          strokeWidth={1.353}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>

      <path
        d="M57.06 53.559c-.16.8-.153 1.626.014 2.42"
        stroke="#272C33"
        strokeWidth={1.807}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M73.687 39.36c-2.547-.38-8.853-1.68-14.673-6.828-5.227-4.62-7.354-9.946-8.16-12.413-.387 2.687-1.46 7.573-4.94 12.52-4.88 6.933-11.454 9.694-14.02 10.62-1.294-.707-.314-.8-.82-2.18-.46-1.253-.927-3.393-1.087-4.72-.193-1.653.273-4.887.573-6.52.214-1.133.54-2.32 1.02-3.767 1.027-3.106 2.094-6.326 4.38-9.433 2.987-4.067 6.647-6.053 8.514-7.04 5.686-3 10.833-3.167 12.373-3.173 1.78 0 3.14.173 3.707.26 6.386.946 10.626 4.2 12.353 5.553 3.52 2.767 5.513 5.673 6.107 6.587 6.353 9.666 4.1 19.82 3.493 21.706-.213.66-.947 2.967-1.307 2.894-.053-.014-.086-.074-.106-.12"
        fill="#2BA168"
      />

      <path
        d="M61.207 23.188c3.707 8.506 11.2 15.973 19.533 20.073L61.207 23.187Z"
        fill="#2BA168"
      />

      <path
        d="M33.147 42.8c10.466-5.487 16.08-11.694 17.513-23.214.353 1.02.88 2.393 1.66 3.953.526 1.047 2.633 5.114 6.133 8.474 5.587 5.366 12.567 6.886 15.227 7.346"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M61.206 23.188c3.707 8.506 11.134 15.94 19.467 20.04"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M44.153 46.352c2.887.24 4.867 1.78 4.867 1.78s-1.987.3-4.353 1.78M69.187 46.352c-2.887.24-4.867 1.78-4.867 1.78s1.987.3 4.354 1.78M59.5 64.283c1.9.173 2.553-2.047 1.346-3.187-.753-.713-1.926-1.26-3.76-1.26-1.833 0-2.993.553-3.733 1.267-1.193 1.146-.547 3.133 1.353 3.186.52.014 1.32-.486 2.407-.486 1.074 0 1.873.433 2.394.486l-.007-.006Z"
        stroke="#272C33"
        strokeWidth={1.88}
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M106.207 27.731c1.74 2.507.446 5.98-2.507 6.734l-8.187 1.126a.388.388 0 0 1-.393-.566l3.9-7.28c1.733-2.514 5.44-2.52 7.187-.014ZM108.933 44.5c-.993 2.46-4.133 3.167-6.087 1.373l-4.713-5.42a.335.335 0 0 1 .227-.553l7.153-.627c2.653.067 4.42 2.76 3.427 5.22l-.007.007Z"
        fill="#fff"
        stroke="#272C33"
        strokeWidth={2.26}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>

    <defs>
      <clipPath id="HomeFailed_svg__a">
        <path fill="#fff" d="M0 0h128v114H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgHomeFailed);

export default Memo;
